import axios from "axios";

//DESARROLLO
const URL_FARE_DEV = "http://localhost:8081";
//PRODUCCION
const URL_FARE_PRO = "http://server-geospatial.taximundo.com";

export const baseBackend = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const baseFareBackend = axios.create({
  baseURL: URL_FARE_PRO,
});
